// extracted by mini-css-extract-plugin
export default {"satelliteButton":"MapboxCommon_satelliteButton__ZjeY-","icon":"MapboxCommon_icon__YIRIN"};